import get from 'lodash/get';
import navigationConfig from '@/modules/navigation/config';
import TaxonomySelector from '@/modules/taxonomy/selector/Selector';
import { $t } from '@/utils';

delete navigationConfig.navigationUrlConfig['section-premium'];
delete navigationConfig.navigationUrlConfig.geo;

navigationConfig.navigationUrlConfig.focus = {
  text: $t('message.wizard.navigation.focus'),
  value: 'focus',
  icon: 'center_focus_strong',
  component: TaxonomySelector,
  props: {
    label: $t('message.wizard.navigation.chooseFocus'),
    limit: 1,
    additionalFilters: { active: 'yes' },
    type: 'focus',
    key: 'focus-selected',
    validation: 'required',
  },
  getNodeDescription: node => ({
    text: get(node, 'link.entity.title', ''),
    icon: 'text_fields',
  }),
};

navigationConfig.defaultLinkTarget = true;
